import request from "@/utils/request"

export function getSmsLogPageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/SmsLog/GetPageList",
    method: "post",
    data
  })
}
